import { AdditionalServiceType, DriverDetails, ServiceCentreCardDetails, VehicleDetails, WorkType } from "generated/types/types";

export type NewBooking = {
    previousBookingId: number | null;
    vehicleDetails: VehicleDetails | null;
    workDetails: WorkDetails | null;
    selectedServiceCentreDetails: ServiceCentreCardDetails | null;
    driverDetails: DriverDetails | null;
};

export type CompleteNewBooking = {
    previousBookingId: number | null;
    vehicleDetails: VehicleDetails;
    workDetails: WorkDetails;
    selectedServiceCentreDetails: ServiceCentreCardDetails;
    driverDetails: DriverDetails;
    tempBookingReference: string;
};

export type WorkDetails = {
    requestedBookingDates?: Date[];
    workRequired: WorkType[];
    repairOtherText?: string;
    additionalServiceRequested: AdditionalServiceType;
    collectionAddress?: string | null;
    collectionPostCode?: string | null;
    collectionContactNumber?: string | null;
    collectionContactName?: string | null;
    collectionInstruction?: string | null;
    additionalNotes: string | null;
    isDiaryIntegrated?: boolean;
    safetyRecall: boolean;
    safetyRecallText: string;
    collectionAddressSearch?: string; 
};

export enum ContactPreferenceType {
    Sms = "Sms",
    Email = "Email",
}